import { useRouter } from "next/router";

import { Head } from "components/shared/layout/Head";
import { SignUpFlow } from "components/signUp/SignUpFlow";

export default function SignUp() {
  const router = useRouter();
  const { referrer } = router.query;
  if (!router.isReady) return null;
  return (
    <>
      <Head pageTitle="Sign Up" />
      <SignUpFlow
        referrerHandle={typeof referrer === "string" ? referrer : undefined}
        email={
          typeof router.query.email == "string" ? router.query.email : undefined
        }
      />
    </>
  );
}
